import { Tooltip } from "antd";
import type { ChartSeries } from "../types/dashboard.types";

interface BarChartProps {
	data: ChartSeries;
	onBarClick?: (label: string) => void;
}

export function BarChart({ data, onBarClick }: BarChartProps) {
	const max = Math.max(...data.values) * 1.15;

	return (
		<svg
			className="crm-chart"
			viewBox="0 0 520 190"
			role="img"
			aria-label="Binolar kesimida daromad"
		>
			{[0, 1, 2, 3].map((line) => {
				const y = 24 + line * ((190 - 48) / 3);
				return <line key={line} x1="28" x2="492" y1={y} y2={y} />;
			})}
			{data.values.map((item, index) => {
				const width = 52;
				const gap = 18;
				const x = 28 + index * (width + gap);
				const height = (item / max) * 138;

				return (
					<Tooltip key={data.labels[index]} title={`${item} mlrd`}>
						<g
							onClick={(e) => {
								e.stopPropagation();
								onBarClick?.(data.labels[index]);
							}}
							style={{ cursor: onBarClick ? "pointer" : "default" }}
						>
							<rect
								height={height}
								rx="5"
								width={width}
								x={x}
								y={166 - height}
								style={{ transition: "height 0.3s ease, y 0.3s ease" }}
							/>
							<text textAnchor="middle" x={x + width / 2} y="183">
								{data.labels[index]}
							</text>
						</g>
					</Tooltip>
				);
			})}
		</svg>
	);
}
